import type {
  CarTireQuoteOptionCreateApiData,
  CarTireQuoteOptionCreateApiResponses,
  CarTireQuoteOptionDeleteApiData,
  CarTireQuoteOptionDeleteApiResponses,
  CarTireQuoteOptionsAxlesSetApiData,
  CarTireQuoteOptionsAxlesSetApiResponses,
  CarTireQuoteOptionSwapApiData,
  CarTireQuoteOptionSwapApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

/** Adding, swapping and removing the options of a tire offer, and changing their tire count, before the customer answers. */
export const getTireQuoteOptionUrls = {
  postCarTireQuoteOption: responseEndpoint<CarTireQuoteOptionCreateApiData, CarTireQuoteOptionCreateApiResponses>({
    getUrl: ({ carTireQuoteId }) => apiUrl(`car-tire-quotes/${carTireQuoteId}/quote-items/`),
    getBody: ({ carTireQuoteId: _, ...body }) => body
  }),
  postCarTireQuoteOptionSwap: responseEndpoint<CarTireQuoteOptionSwapApiData, CarTireQuoteOptionSwapApiResponses>({
    getUrl: ({ carTireQuoteItemId }) => apiUrl(`car-tire-quote-item/${carTireQuoteItemId}/swap/`),
    getBody: ({ carTireQuoteItemId: _, ...body }) => body
  }),
  postCarTireQuoteOptionsAxles: responseEndpoint<
    CarTireQuoteOptionsAxlesSetApiData,
    CarTireQuoteOptionsAxlesSetApiResponses
  >({
    getUrl: ({ carTireQuoteId }) => apiUrl(`car-tire-quotes/${carTireQuoteId}/quote-items/axles/`),
    getBody: ({ carTireQuoteId: _, ...body }) => body
  }),
  deleteCarTireQuoteOption: dataEndpoint<CarTireQuoteOptionDeleteApiData, CarTireQuoteOptionDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`car-tire-quote-item/${pk}/`)
  })
};
